/*
* @Author: zhangzhitao
* @Date: 2019-06-01 11:13:48
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-06-01 16:38:43
*/

<template>
  <div
    class="m-store-outer"
    :class="{ 'is-open': toolBarSwitch || toolLock }"
    @mouseover="showToolBar"
    @mouseout="hideToolBar"
  >
    <div class="m-tool-bar-inner">
      <ul class="m-tool-top-wrap">
        <li class="draw-tool-btn">
          <div
            class="u-btn"
            @click="_handleApply"
          >
            <i class="iconfont iconb_ic_save"></i>
            <span>{{ $t("management.home.apply_label") }}</span>
          </div>
        </li>
        <li class="draw-tool-btn">
          <div
            class="u-btn"
            @click="_handleSaveModel"
          >
            <i class="iconfont iconb_ic_savefuzhi"></i>
            <span>{{ $t("management.home.save") }}</span>
          </div>
        </li>
        <li class="draw-tool-btn">
          <div
            class="u-btn"
            @click="_handleSaveAs"
          >
            <i class="iconfont iconb_ic_lcwmb"></i>
            <span>{{ $t("management.home.other_save") }}</span>
          </div>
        </li>
        <li class="draw-tool-btn">
          <div
            class="u-btn"
            @click="handleClear"
          >
            <i class="iconfont iconb_ic_trash"></i>
            <span>{{ $t("management.home.claer_board") }}</span>
          </div>
        </li>
        <li
          class="select-mode-btn"
          @click="modelDialog = !modelDialog"
        >
          <div class="u-model-btn">
            <i class="iconfont iconb_ic_ggzs"></i>
            <span>{{ $t("management.home.draw_model") }}</span>
          </div>
          <div
            class="m-mode-drapdown"
            v-show="modelDialog"
          >
            <div
              class="u-column"
              @click="handleChangeDrawModel('full')"
            >
              {{ $t("management.home.full_type") }}
            </div>
            <div
              class="u-column"
              @click="handleChangeDrawModel('limit')"
            >
              {{ $t("management.home.limit_type") }}
            </div>
          </div>
        </li>
        <li
          class="lock-tool-btn"
          @click="toolLock = !toolLock"
        >
          <i
            class="iconfont iconb_ic_guding"
            v-if="toolLock"
          ></i>
          <i
            class="iconfont iconcommon_guding_f"
            v-else
          ></i>
          <span v-if="toolLock">{{
            $t("management.home.unfixed_operation_bar")
            }}</span>
          <span v-else>{{ $t("management.home.fixed_operation_bar") }}</span>
        </li>
      </ul>
      <div class="m-tool-bottom-wrap">
        <widget-store-filter
          :typeTag="typeTag"
          @typeTag="handleTypeTag"
          :activeWidgetClassify="activeWidgetClassify"
          @classify="handleWidgetClassify"
        ></widget-store-filter>
      </div>
    </div>
  </div>
</template>

<script>
import widgetStoreFilter from './widget-store-filter'
export default {
  name: 'widget-store',
  data () {
    return {
      // 控制操作区模式
      modelDialog: false,
      // 锁定工具部件抽屉
      toolLock: true,
      // 管理部件栏显隐
      toolBarSwitch: false,
      // 部件/模板
      typeTag: 'widget',
      // 当前选中的部件类型
      activeWidgetClassify: 'all'
    }
  },

  components: { widgetStoreFilter },

  computed: {},

  mounted () { },

  methods: {
    // 应用
    _handleApply () { },
    // 保存为模板
    _handleSaveModel () { },
    // 另存为
    _handleSaveAs () { },
    // 清空面板
    handleClear () { },
    // 画板模式切换
    handleChangeDrawModel (command) { },
    // 是否锁定工具栏
    showToolBar () {
      if (!this.toolLock) {
        this.toolBarSwitch = true
      }
    },
    hideToolBar () {
      if (!this.toolLock) {
        this.toolBarSwitch = false
      }
    },
    // 部件类型选择
    handleWidgetClassify (code) {
      this.activeWidgetClassify = code
    },
    // 部件/模板
    handleTypeTag (type) {
      this.typeTag = type
    }
  }
}

</script>

<style lang="scss" scoped>
.m-store-outer {
  position: absolute;
  left: 0;
  top: -224px;
  width: 100%;
  height: 244px;
  padding-bottom: 20px;
  box-sizing: border-box;
  transition: all 0.3s;
  z-index: 6;
  user-select: none;
  &.is-open {
    top: 0px;
  }
  .m-tool-bar-inner {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
    .m-tool-top-wrap {
      width: 100%;
      height: 48px;
      list-style: none;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      li {
        position: relative;
        float: left;
        margin-right: 24px;
        height: 48px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.7);
        cursor: pointer;
        i {
          margin-right: 8px;
          font-size: 16px;
          float: left;
        }
      }
      // li:hover {
      //   color: rgba(0, 0, 0, 0.9);
      // }
      .draw-tool-btn {
        .u-btn {
          height: 32px;
          line-height: 32px;
          padding: 0 8px;
          margin: 8px 0;
          i {
            font-size: 24px;
          }
        }
        .u-btn:hover {
          background: rgba(0, 0, 0, 0.08);
        }
      }
      .select-mode-btn {
        line-height: 48px;
        .m-mode-drapdown {
          position: absolute;
          top: 40px;
          left: 24px;
          background: #fff;
          width: 120px;
          padding: 8px;
          box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);
          z-index: 999;
          .u-column {
            width: 100%;
            box-sizing: border-box;
            line-height: 32px;
            padding: 0 10px;
          }
          .u-column:hover {
            background: rgba(0, 0, 0, 0.1);
          }
        }
        .u-model-btn {
          float: left;
          height: 32px;
          line-height: 32px;
          padding: 0 8px;
          margin-top: 8px;
          i {
            font-size: 24px;
          }
        }
        .u-model-btn:hover {
          background: rgba(0, 0, 0, 0.08);
        }
      }
      .select-mode-btn::before {
        content: "";
        display: block;
        float: left;
        margin-top: 12px;
        margin-right: 16px;
        width: 1px;
        height: 24px;
        background: rgba(0, 0, 0, 0.12);
      }
      .lock-tool-btn {
        float: right;
        line-height: 48px;
        margin-right: 0;
        i {
          font-size: 24px;
        }
      }
    }
    .m-tool-bottom-wrap {
      width: 100%;
      height: calc(100% - 48px);
    }
  }
}
</style>
